import { openExternalLink } from './fnUtils'

export const openWhatsappSupport = (): void => {
  openExternalLink(process.env.REACT_APP_WHATSAPP_SUPPORT_URL)
}
